/* ───────── raw DTO от бекенда ───────── */
export interface RawAnalysis {
  user_name: string;
  description: string;
}

/* ───────── enum типов оплаты ───────── */
export enum PaymentType {
  FREE = 'free',
  FRANCHISE = 'franchise',
  SELF_PAY = 'self_pay',
  UNCONFIRMED_FRANCHISE = 'unconfirmed_franchise',
}

/* статусы — переиспользуем и для заказов, и для сетов */
export enum AnalysisOrderStatus {
  NEW = 'NEW',
  SENT = 'SENT',
  PLACED = 'PLACED',
  RESULTED = 'RESULTED',
  EXPIRED = 'EXPIRED',
  ERROR = 'ERROR',
}

export interface RawAnalysisSet {
  complex_id: number;
  complex_name?: string | null;
  set_name: string;
  price: number;
  rcc_price: number;
  payment_type?: PaymentType;
  status?: AnalysisOrderStatus;
  analyses: RawAnalysis[];
}

export type AnalysisRecommendationStatus = 'pending' | 'completed' | 'failed' | string;

export interface RawAnalysisResponse {
  request_id: number;
  risk_request_id?: number | null;
  status?: AnalysisRecommendationStatus;
  created_at?: string | null;
  finished_at?: string | null;
  error?: string | null;
  program_month: number | null;
  recommended_analyses: RawAnalysisSet | null;
  vitamins: RawAnalysisSet | null;
}

/* ───────── DTO для создания и ответа ───────── */
export interface CreateAnalysisOrderPayload {
  complex_ids: number[];
}

export interface RawAnalysisOrderResponse {
  id: number;
  order_link: string;
  recommended_status: AnalysisOrderStatus;
  vitamins_status: AnalysisOrderStatus;
  created_at: string; // ISO-8601
}

/* ───────── redux-state ───────── */
export interface AnalysisState {
  data: RawAnalysisResponse | null;
  loading: boolean;
  polling: boolean;

  orderLoading: boolean;
  orderError: string | null;

  error: string | null;

  results: AnalysisResultsResponse | null;
  resultsLoading: boolean;
  resultsError: string | null;
}

/* --- результат значений --- */
export interface AnalysisValue {
  id: number;
  name: string;
  type: string;
  value: number | string;
  min: number | null;
  max: number | null;
  units: string;
  isNormal: boolean;
}

export interface AnalysisProduct {
  productId: number;
  productCode: string;
  name: string;
  isNormal: boolean;
  values: AnalysisValue[];
}

export interface AnalysisComplexResult {
  complexId: number;
  kind: string;
  resultedAt: string | null;
  expiredAt: string | null;
  items: AnalysisProduct[];
}

export interface AnalysisResultsResponse {
  orderId: number;
  complexes: AnalysisComplexResult[];
}
